import CompanyCommercialsV2 from "@/pages/companies/components/CompanyCommercialsV2/CompanyCommercialsV2";
import { CompanyData } from "@/pages/companies/types";
import { DealData } from "@/pages/deals/types";
import { EntityData } from "@/services/api/types";
import { EntityType } from "@/services/hooks/entities/useEntityType";
import React from "react";
import DealCommercialsV2 from "./DealCommercialsV2/DealCommercialsV2";

interface Props {
  entityType: EntityType;
  entityData: EntityData;
  onDealUpdate?: (updatedFields: Partial<DealData>) => void;
}

const Commercials: React.FC<Props> = ({
  entityType,
  entityData,
  onDealUpdate
}) => {
  return entityType === EntityType.DEAL ? (
    <DealCommercialsV2
      dealData={entityData as DealData}
      onDealUpdate={onDealUpdate}
    />
  ) : entityType === EntityType.COMPANY ? (
    <CompanyCommercialsV2 companyData={entityData as CompanyData} />
  ) : null;
};

export default Commercials;
